import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ChevronRight, LucideAngularModule } from 'lucide-angular';
import { environment } from '../../../../environments';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [RouterModule, LucideAngularModule],
  templateUrl:
    environment.theme.default === 'dpp'
      ? './banner.dpp.component.html'
      : './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  @Input() title: string = 'Dossier Patient Partagé';
  @Input() links: { label: string; href?: string }[] = [];
  readonly ChevronRight = ChevronRight;
}
